export const getAssignListBadge = (payload?: any) => ({
    type: "@saga/GET_ASSIGN_LIST_BADGE",
    payload
});